import { render, staticRenderFns } from "./DxDetailTabAttachment.vue?vue&type=template&id=2dd77384&"
import script from "./DxDetailTabAttachment.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports